type SafeEmailTextProps = {
  className?: string;
  email?: string;
};

const DEFAULT_EMAIL_LOCAL = "hello";
const DEFAULT_EMAIL_DOMAIN = "letsroave.com";

const getEmailParts = (email?: string) => {
  const value = email || `${DEFAULT_EMAIL_LOCAL}@${DEFAULT_EMAIL_DOMAIN}`;
  const [localPart, ...domainParts] = value.split("@");
  const domainPart = domainParts.join("@");

  return {
    localPart: localPart || DEFAULT_EMAIL_LOCAL,
    domainPart: domainPart || DEFAULT_EMAIL_DOMAIN,
  };
};

const SafeEmailText = ({ className, email }: SafeEmailTextProps) => {
  const { localPart, domainPart } = getEmailParts(email);

  return (
    <span className={className}>
      <span>{localPart}</span>
      <span>@</span>
      <span>{domainPart}</span>
    </span>
  );
};

export default SafeEmailText;
